import React, { Component } from "react";
// reactstrap components
import { FormGroup, Label, Input, Row } from "reactstrap";

export default class BooleanCustom extends Component {
  displayError() {
    const error = this.props.error;
    if (typeof error != "undefined" && error != null) {
      return <div className='text-danger'>{error.text}</div>;
    }
  }

  render() {
    return (
      <div className='pt-3 border-top'>
        <p className='font-weight-bold mb-4'><span >{this.props.qIndex}. {this.props.label}</span></p>
        <Row className='form'>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              name={this.props.name}
              id={`${this.props.name}_value_${this.props.trueOption}`}
              value={true}
              checked={this.props.currentValue === true}
              onChange={(e) => {
                console.log("likert prop name: ", this.props.name);
                this.props.handleChange(this.props.name, true);
              }}
              className="custom-control-input"
            />
            <Label htmlFor={`${this.props.name}_value_${this.props.trueOption}`} className='custom-control-label'>
              {this.props.trueOption}
            </Label>
          </FormGroup>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              name={this.props.name}
              id={`${this.props.name}_value_${this.props.falseOption}`}
              value={false}
              checked={this.props.currentValue === false}
              onChange={(e) => {
                console.log("likert prop name: ", this.props.name);
                this.props.handleChange(this.props.name, false);
              }}
              className="custom-control-input"
            />
            <Label htmlFor={`${this.props.name}_value_${this.props.falseOption}`} className='custom-control-label'>
              {this.props.falseOption}
            </Label>
          </FormGroup>
        </Row>
        {this.displayError()}
      </div>
    );
  }
}
